import React, { useEffect, useState } from 'react';
import Navbar from 'src/components/Navbar';
import Sidebar from 'src/components/Sidebar';
import Institution from 'src/views/Institucional/InstComponents';

import bgImage from 'src/assets/pages/institucional-bg.webp';
import Footer from 'src/components/Footer';
import ServicesSection from 'src/components/ServicesSection';
import GeneralBanner from 'src/components/GeneralBanner';
import { Colors, LoadIcon } from 'src/styles/DesignSystem';
import axios from 'axios';


const Institucional = () => {

    // Controles do menu
    const [isOpen, setIsOpen] = useState(false);
    const toggle = ()=>{
        setIsOpen(!isOpen);
    }

    // Fetch Data from API
    const [data, setData] = useState({});
    const [servicos, setServicos] = useState({});
    const [isLoaded, setIsLoaded] = useState(false);

    useEffect(() => {
        const fetching = async () => {
            const { data } = await axios.get(`https://hipermercadodasracoes.com/system/wp-json/wp/v2/sobre`);
            const respServices = await axios(`https://hipermercadodasracoes.com/system/wp-json/wp/v2/servicos`);

            setServicos(respServices.data);
            setData(data[0]);
            setIsLoaded(true);
        };
        fetching();
    }, [setData, setServicos]);

    if(!isLoaded){
        return(
          <>
            <LoadIcon />
          </>
        )
    }

    return (
        <>
            <Navbar isOpen = {isOpen} toggle={toggle} page="institucional"/>
            <Sidebar isOpen = {isOpen} toggle={toggle} page='institucional'/>

            <GeneralBanner wd={25} bgImage={bgImage} title='Sobre nós'/>
            <Institution
                title= {data.acf.titulo}
                subtitle={data.acf.sobre}
                description={data.acf.descricao}
                img01={data.acf.img_sobre_01}
                img02={data.acf.img_sobre_02}
                img03={data.acf.img_sobre_03}
                slides={data.acf.slides_institucional}
            />
            
            <Footer 
                firtsComponent={
                    <ServicesSection 
                        title="Conheça nossos serviços"
                        titleColor={Colors.lighBrown}
                        padding={10}
                        services={servicos}
                    />
                }
            />
        </>
    )
}

export default Institucional;